const userStatus = {
    DELETED: '0',
    BLOCKED: '8',
    INACTIVE: '9',
    ACTIVE: '10',
}
export { userStatus }